import PATH from "constants/path";
import { createAction, createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { getInfoResponse } from "utils/common";
import { saveUserInfo } from "features/User/userSlice";
import promotionAPI from "api/promotionAPI";

const addPartner = createAction("PROMOTION_ADD_PARTNER");
const updatePartner = createAction("PROMOTION_UPDATE_PARTNER");
const deletePartner = createAction("PROMOTION_DELETE_PARTNER");

const getPromotion = createAsyncThunk(
  "GET_PROMOTION",
  async (_arg, { dispatch, rejectWithValue }) => {
    try {
      let isInLine = false;
      const res = await promotionAPI.getPromotion(_arg);
      dispatch(saveUserInfo(getInfoResponse(res)));
      if(res.sorrypage == '0') {
        return {
          promotion: null,
          promotion_set: null,
          isInLine: true,
          flag_button: null
        }; 
      }
      return {
        promotion: res.data.promotion,
        promotion_set: res.data.promotion_set,
        isInLine: isInLine,
        flag_button: res.data.flag_button
      }; 
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

const clearApplyPromotion = createAction("CLEAR_APPLY_PROMOTION");
const clearMessage = createAction("CLEAR_MESSAGE");
const applyPromotion = createAsyncThunk(
  "APPLY_PROMOTION",
  async (_arg, { dispatch, rejectWithValue }) => {
    try {
      const res = await promotionAPI.postEntry(_arg);
      dispatch(saveUserInfo(getInfoResponse(res)));
      return res;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

const initialState = {
  list: [], 
  promotion: null,
  promotion_set: null,
  message: null,
  applySuccess: null,
  isInLine: false,
  flag_button: false
};

const promotionSlice = createSlice({
  name: "promotion",
  initialState,
  extraReducers: {
    [getPromotion.fulfilled]: (state, action) => {
      state.promotion = action.payload.promotion;
      state.promotion_set = action.payload.promotion_set;
      state.isInLine = action.payload.isInLine;
      state.flag_button = action.payload.flag_button;
    },
    [applyPromotion.fulfilled]: (state, action) => {
      if (action.payload.status === "success") {
        state.applySuccess = true;
        state.isInLine = false;
      }else if(action.payload.status === "fails"){
        state.message = action.payload.message;
        state.isInLine = false;
      } else {
        // window.location.replace("#" + PATH.ERROR_404);
        state.isInLine = true;
      }
    },

    [clearApplyPromotion]: (state) => {
      state.applySuccess = null;
      state.promotion_set = null;
      state.message = null;
      state.promotion = null;
      state.list = [];
    },
    [clearMessage]: (state) => {
      state.message = null;
    },
    [addPartner]: (state, action) => {
      state.list = [...state.list, action.payload];
    },

    [updatePartner]: (state, action) => {
      const foundIndex = state.list.findIndex(
        (p) => JSON.stringify(p) === JSON.stringify(action.payload.partner)
      );
      let newArr = state.list;
      newArr[foundIndex] = action.payload.update_partner;
      state.list = newArr;
    },

    [deletePartner]: (state, action) => {
      const { partner, promotionset_id } = action.payload;
      // get index partner
      const foundIndex = state.list.findIndex(
        (p) => JSON.stringify(p) === JSON.stringify(partner)
      );

      let newArr = state.list;
      // update promotion_set_id for partner
      newArr[foundIndex].promotion_set_id = partner.promotion_set_id.filter(
        (item) => +item !== promotionset_id
      );

      // delete partner
      newArr.filter((item) => item.promotion_set_id.length < 1);
      state.list = newArr;
    },
  },
});

const { reducer } = promotionSlice;
export { 
  getPromotion, 
  applyPromotion, 
  clearApplyPromotion, 
  clearMessage,
  addPartner,
  deletePartner,
  updatePartner, 
};
export default reducer;
